import { createSlice } from '@reduxjs/toolkit'

export interface InitState {
  currentTab: number
}

const initialState: InitState = {
  currentTab: 2,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload
    },
  },
})

export const { setCurrentTab } = appSlice.actions

export default appSlice.reducer
